import { Button, Grid, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import { WASHUB_CONSTANTS } from '../../../shared/Constants';
import { useAPI } from '../../../shared/services/api/API';

export const TrollyInventoryReport = () => {
  const { axiosInstance, handleAlertBar } = useAPI();
  const [ isLoading, setIsLoading] = useState<boolean>(false);
  // Post with API: Print Garment summary report
  const downloadTrollyInventryReport = async () => {
    setIsLoading(true);
    axiosInstance
      .post(
        WASHUB_CONSTANTS.API_URLS.TROLLY_INVENTORY_REPORT_DATA_GET,
        {},
        {
          headers: {
            Authorization: localStorage.getItem('jwtToken') || null,
          },
          responseType: 'blob',
        }
      )
      .then((response: any) => {
        if (response.status === 200) {
        const blob = new Blob([response.data], { type: 'application/xlsx' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.setAttribute(
          'download',
          `trolly-inventory-report.xlsx`
        );
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        handleAlertBar("error", `No trolly's in transit`)
      }
        setIsLoading(false);
      })
      .catch((err) => {
        handleAlertBar("error", `No trolly's in transit`)
        setIsLoading(false);
      });
  };
  return (
        <div style={{ width: '100%' }}>
      <Grid container justifyContent={'space-between'}>
        <Grid item className="mb-1 mt-1 ms-3">
          <Typography
            color={'primary'}
            sx={{ textAlign: 'center' }}
            variant="h5"
            className="mt-0"
          >
            Trolly Inventory Report
          </Typography>
        </Grid>
      </Grid>
      <div style={{ margin: '5px 15px', borderTop: '2px solid #25BCCA' }}></div>
      <Grid container justifyContent={'space-between'}>
        <Grid item className="mb-1 mt-1 ms-3">
          <Stack spacing={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => downloadTrollyInventryReport()}
              disabled={isLoading}
            >
              Download Trolly Inventory Report
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </div>
  )
}